import ListFieldsGeneric from './ListFieldsGeneric'
let ListFields = ListFieldsGeneric('Preis')

export default {
  label: 'Preis',
  route: 'preis',
  className: 'preis',
  fields: [
    ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true),
    ListFields.SortableTimestamp('_createDate', false, 'createDate', true),
    ListFields.SortableReference('organisationseinheit', false),
    ListFields.SortableReference('preisTraeger', true),
    ListFields.SortableField('verleihungsJahr', true),
    ListFields.SortableField('namePreis', true),
    ListFields.SortableReference('preisBezeichnung', false, 'preisBezeichnungSearchRep', true),
    ListFields.SortableField('hatPreisgeld', true, Boolean)
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/Preis.js